import { catchError, switchMap, filter, map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from './../../auth.service';
import { ApiService } from './../../api.service';
import { UserProfileService } from './../../api/user-profile.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';
import { DataObject } from '../../interfaces/data-objects';

@UntilDestroy()
@Component({
  selector: 'iv-home',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private apiService: ApiService,
    private userProfileService: UserProfileService
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams
    .pipe(
      untilDestroyed(this),
      filter((params: any) => {
        if (params && params.code) {
          return params;
        }
      }),
      switchMap((params: DataObject) => {
        return this.apiService.getAuthToken(params.code);
      }),
      switchMap((tokenResponse: DataObject) => {
        if (tokenResponse.jwt) {
          this.authService.setToken(tokenResponse.jwt);
          this.authService.setPort(tokenResponse.port);
          const getEmployeeId$ = this.userProfileService.getEmployeeId();
          return getEmployeeId$
            .pipe(
              map((employeeInfo: DataObject) => {
                return {
                  employee: { 
                    ...employeeInfo.result,
                  },
                  jwt: tokenResponse.jwt,
                  port: tokenResponse.port,
                };
              })
            );
        } else {
          return of({
            jwt: tokenResponse.jwt,
            port: tokenResponse.port,
            employee: {},
          });
        }
      }),
      catchError(error => {
        throw error;
      })
    )
    .subscribe(
      (response: DataObject) => {
        if (response.jwt && response.employee) {
            /* INFO: SSO Redirection Issue
            * Will fix the issue when the user logs in for the first time and, 
            * where the app redirects to 'en-US' (main redirection in Nginx) even when the user's current language is different or
            * a Deep Linking URL has a different userlocale (en-IN, cn, zh, etc...)
            * 
            * The previousURL is only set in a Deep Linking scenario.
            */
            if (this.authService.getLastUrl() && !this.authService.getPreviousURL()) {
              window.location.href = environment.finishlineurl + (this.authService.getLastUrl().substring(1));
            } else if (this.authService.getPreviousURL() && this.authService.getPreviousURL().includes('deeplinking')) { 
              window.location.href = environment.finishlineurl + (this.authService.getPreviousURL().substring(1));
            } else {
              this.router.navigateByUrl('/');
            }
        } else {
          this.router.navigateByUrl('/unauthorized');
        }
      },
      err => console.log(err)
    );
  }

  /**
   * INFO: In case the response_mode was other than query in the environment file.
   */
  getTokenId(data: any): any {
    if (data) {
      let tokenId = data.split('&')[0];
      tokenId = tokenId.split('id_token=')[1];
      return tokenId;
    }
    return null;
  }

}

